import React from "react"
import Ajax from 'superagent'
import {values} from "lodash"
import {Dialog, Button, Icon, Toptips} from "react-weui"
import { X } from "react-feather"
import PropTypes from "prop-types"

import './RoomModal.less'

const IconFromStatus = {
  loading: 'loading',
  success: 'success-no-circle',
  failed: 'cancel'
}

export default class RoomModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      upgradeRequested: false
    }
  }

  sendVerification() {
    Ajax.post("/startVerification")
      .send({
        prefix: this.props.prefix,
        phone: this.props.phone
      })
      .then()
  }

  componentDidMount() {
    this.sendVerification()
  }

  render() {
    const { onClose, room } = this.props
    return  (
      <React.Fragment>
        <Dialog
          id="RoomModal"
          type="ios"
          show 
          style={{
            maxWidth: window.matchMedia("(min-width: 735px)").matches ? "360px" : "65%",
            width: window.matchMedia("(min-width: 735px)").matches ? "360px" : "65%",
          }}
        >
          <header>
            <X size="30px" onClick={() => onClose()} />
          </header>

          <section>
            <h2>注意:</h2>
            {this.state.upgradeRequested
              ? (<p>非常感谢！Palacio de Tepa 尽快要联系您</p>)
              : (<p>您确定要交换到 {room.title}, 每晚需支付150欧元的额外费用吗？</p>)
            }
            <Button
              className={`advanceButton`}
              onClick={() => {
                if (!this.state.upgradeRequested) {
                  this.setState({upgradeRequested: true})
                  this.props.onSuccess()
                }
                else {
                  onClose() 
                }
              }}
            >
              <p className="buttonText">{!this.state.upgradeRequested ? "确定" : "关闭"}</p>
            </Button>
          </section>
        </Dialog>
      </React.Fragment>
      
    )
  }
}

RoomModal.propTypes = {
  menu: PropTypes.object.isRequired, 
  onClose: PropTypes.func, 
}


// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/components/RoomModal.jsx